(ns practitest.frontend.components2.grid.save-filter-modal
  (:require [practitest.frontend.common.dom :as dom]
            [practitest.frontend.common.i18n :refer [get-translation format-translation]]
            [practitest.frontend.common.tooltip :as common-tooltip]
            [practitest.frontend.components2.buttons :as buttons]
            [practitest.frontend.components.icons :as icons]
            [practitest.frontend.common.mixpanel :as mixpanel]
            [clojure.string :as str]
            [re-frame.core :as re-frame]
            [practitest.frontend.components.modal :refer [bootstrap-modal]]
            [ajax.core :as ajax]
            [practitest.frontend.components.notifications :as notifications]
            [practitest.frontend.events :as events]
            [practitest.frontend.components.grid.server :as server]
            [practitest.frontend.routing.router :as router]
            [practitest.frontend.routing.backend-routes :as broutes]
            [re-frame.core :as re-frame]
            [clojure.string :as str]
            [practitest.frontend.subs :as subs]
            [practitest.frontend.components.grid.subs :as grid.subs]
            [reagent.core :as reagent]
            [practitest.frontend.components2.grid.common :as common]
            [practitest.frontend.components.grid.filters :as oldfilters]))

(defn save-filter-modal [_]

  (let [filter-name (reagent/atom "")
        public-filter? (reagent/atom true)]

    (fn [{:keys [on-close grid-props show-modal?]}]
      (let [{:keys [grid-state fields]} grid-props
            autofilters-state (:autofilters-state @grid-state)
            module (:module @grid-state)
            entity-type (keyword (str/lower-case module))
            state-key (entity-type subs/index-grid-keys)
            current-view @(re-frame/subscribe [::grid.subs/current-view entity-type state-key])
            current-view-id (:id current-view)
            selected-fields @(re-frame/subscribe [::grid.subs/filter-cols entity-type state-key])
            parent-id (if (= current-view-id "_DEFAULT_") nil current-view-id)
            is-parent-public (or (= current-view-id "_DEFAULT_") (:is_public current-view))
            close-modal (fn []
                          (reset! filter-name "")
                          (reset! public-filter? true)
                          (on-close))]
            [bootstrap-modal
             {:is-open? @show-modal?
              :on-request-close close-modal
              :close-button? true
              :scrollable? true
              :centered? true
              :class "custom-modal-size"}
             (get-translation "grid.fast-filters.modal.headline" "Create a new filter")
             [:div
              [:label {:for "filter-name"}
               (get-translation "generic.label.name" "Name")]
              [:input.form-control.mb-3
               {:id "filter-name"
                :type "text"
                :placeholder
                (get-translation "test.steps.test-name-placeholder" "Enter name")
                :value @filter-name
                :on-change #(reset! filter-name (-> % .-target .-value))}]
              [:div.m-checkbox-container
               [:label.m-checkbox-label
                [:input.m-checkbox
                 {:type      "checkbox"
                  :checked   (if is-parent-public @public-filter? false)
                  :disabled  (not is-parent-public)
                  :on-change #(reset! public-filter? (not @public-filter?))}]
                (get-translation "grid.fast-filters.modal.public-filter" "Public filter")]

               [common-tooltip/info-circle-tooltip
                [:span (get-translation "grid.fast-filters.modal.private-or-public.tooltip"
                                        "Uncheck this checkbox if you want to make this filter available only for you (Private)")]]]

              (when (not= (:id current-view) "_DEFAULT_")
                [:div.m-note-container
                 [:span
                  (format-translation
                    (get-translation "grid.fast-filters.modal.sub-filter.note"
                                     "Note - This filter will be created as a sub-filter under [%{filter_name}]")
                    :filter_name (:name current-view))]

                 [common-tooltip/info-circle-tooltip
                  [:span (get-translation "grid.fast-filters.modal.sub-filter.tooltip"
                                          "To create an unrelated filter, go to 'All Entities' and create it there.")]]])]

             [:div.d-flex.justify-content-end.gap-2.mb-2
              [buttons/button
               {:on-click close-modal
                :text (get-translation "generic.button.cancel" "Cancel")}]
              [buttons/button
               {:disabled? (str/blank? @filter-name)
                :on-click (fn [e]
                            (dom/prevent-default e)
                            (let [is-public (if is-parent-public @public-filter? false)]
                              (mixpanel/track "Grid Actions"
                                              {"Action" "Save Fast Filter"
                                               "Entity" (mixpanel/entity-type->mixpanel entity-type)
                                               "Type" (if is-public "Public" "Private")})
                              (re-frame/dispatch [::save-filter
                                                  @filter-name
                                                  is-public
                                                  autofilters-state
                                                  parent-id
                                                  fields
                                                  selected-fields
                                                  grid-props]))
                            (close-modal))
                :icon (icons/mux-plus-circle)
                :text (get-translation "grid.fast-filters.modal.save-filter-button" "Save")
                :primary? true}]]]))))

(re-frame/reg-event-fx
  ::save-filter
  (fn [{:keys [db]} [_ filter-name public-filter filters parent-id fields selected-fields grid-props]]
    (let [project-id (subs/get-current-project-id db)
          route (broutes/get-route "custom_views#create_from_fast_filters" {:project_id project-id})
          {:keys [grid-state]} grid-props
          entity-type (:module @grid-state)
          payload {:name filter-name
                   :is_public public-filter
                   :hide_empty_auto_filters false
                   :filters (server/process-autofilters filters fields)
                   :selected_fields selected-fields
                   :parent_id parent-id
                   :entity_type entity-type}]
      {:db (update db :progress conj ::save-filter)
       :http-xhrio
       {:method (:method (:data route))
        :uri (:path route)
        :params payload
        :format (ajax/json-request-format)
        :response-format (ajax/json-response-format {:keywords? true})
        :on-success [::save-filter-success grid-props]
        :on-failure [::events/api-error ::save-filter
                     {:message
                      (get-translation "grid.fast-filters.notification.save-error" "Error saving filter")}]}})))

(re-frame/reg-sub
  ::new-filter-id
  (fn [db _]
    (get db :new-filter-id nil)))

(re-frame/reg-event-fx
  ::save-filter-success
  (fn [{:keys [db]} [_ grid-props response]]
    (let [{:keys [grid-state]} grid-props
          {:keys [status redirect_to message]} response
          success?     (= "ok" status)
          new-filter-id (when success?
                          (second (re-find #"cv=(\d+)" redirect_to)))]
      (when success?
        (router/update-query-params! assoc :cv new-filter-id)
        (swap! grid-state dissoc :autofilters-state)
        (oldfilters/on-filter-changed grid-props))
      {:db (-> db
               (update :progress disj ::save-filter)
               (cond-> success? (assoc :new-filter-id new-filter-id)))
       :dispatch-n (if success?
                     [[::notifications/success2
                       (get-translation "grid.fast-filters.notification.saved"
                                        "Filter was successfully saved")
                       {:auto-close notifications/auto-close-success-timeout}]]
                     [[::notifications/error2
                       (common/extract-error-message message)
                       {:auto-close 10000}]])})))
